module.exports = __webpack_public_path__ + "img/icn_bits_transparent.3842d969.svg";